export class JobDescription {
  constructor(private readonly key: string, private readonly title: string, private readonly isGeneric: boolean, private readonly enabled: boolean) {}

  public getKey(): string {
    return this.key;
  }

  public getTitle(): string {
    return this.title;
  }

  public getIsGeneric(): boolean {
    return this.isGeneric;
  }

  public getEnabled(): boolean {
    return this.enabled;
  }

  public isNew(): boolean {
    return !!this.key;
  }
}
